import { Link } from "react-router-dom";

const faqs = [
  {
    q: "What is Vigorbuy Spreadsheet?",
    a: "Vigorbuy Spreadsheet is a comprehensive spreadsheet solution for organizing data, managing inventory, tracking products and improving workflow efficiency. It offers structured templates, automation features and user-friendly interfaces suitable for both beginners and professionals.",
  },
  {
    q: "Is Vigorbuy Spreadsheet safe to use?",
    a: "Yes, Vigorbuy Spreadsheet is safe when used through official channels. Always verify you are using authentic resources, avoid downloading from unverified sources and follow recommended security practices such as using strong passwords and keeping your data private.",
  },
  {
    q: "How do I get started with Vigorbuy Spreadsheet?",
    a: "Getting started is simple. Visit the official website, explore available templates and begin with the beginner-friendly guides. You can find step-by-step tutorials, template downloads and expert tips in our comprehensive resource section to help you master the tool quickly.",
  },
  {
    q: "What templates are available in Vigorbuy Spreadsheet?",
    a: "Vigorbuy Spreadsheet offers a wide range of templates including business management, inventory tracking, product cataloging, sales reports, budget planning and more. Templates are designed to be flexible and customizable to fit various use cases.",
  },
  {
    q: "How does Vigorbuy Spreadsheet compare to Excel or Google Sheets?",
    a: "Vigorbuy Spreadsheet provides more specialized templates and structured systems compared to traditional spreadsheets. While Excel and Google Sheets offer general-purpose functionality, Vigorbuy Spreadsheet focuses on delivering ready-to-use solutions for specific business and data management needs.",
  },
  {
    q: "Can beginners use Vigorbuy Spreadsheet effectively?",
    a: "Absolutely. Vigorbuy Spreadsheet is designed with beginners in mind. The interface is intuitive, templates are pre-configured and comprehensive guides walk you through every feature. Most users can become productive within hours of getting started.",
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            Find answers to the most common questions about Vigorbuy Spreadsheet.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-50 border border-background-200/60 rounded-lg overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer font-label font-medium text-foreground-800 text-sm hover:text-primary-600 transition-colors">
                {faq.q}
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 ml-3 group-open:hidden">
                  <i className="ri-add-line text-foreground-500"></i>
                </span>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 ml-3 hidden group-open:flex">
                  <i className="ri-subtract-line text-primary-500"></i>
                </span>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/vigorbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 text-sm font-label font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            View More Guides
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}